import {
  ApplicationResource,
  DetailedResource,
  getResourceMuleVersion,
  isApplicationResource
} from '../../../common/resource/model'

export const getMuleVersion = (detailedResource: DetailedResource) => {
  const mayContainMuleVersion = detailedResource && isApplicationResource(detailedResource)
  const applicationResource = (detailedResource as ApplicationResource)

  return mayContainMuleVersion ? getResourceMuleVersion(applicationResource) : undefined
}
